<template>
  <v-dialog v-model="dialog" max-width="480px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("shopDailyReports.shopDailyExtPull") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="text-left my-2">
              {{ $t("shopDailyReports.daily_date") }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <SearcherDatetimeRange
                type="date"
                v-model="datetimeRage"
                @changedModel="datetimeRageChanged = $event"
              />
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="primary" depressed @click="extPull()">
          {{ $t("shopDailyReports.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "@/i18n";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import shopDailyReports from "@/api/shop_daily_reports"

export default {
  name: "ShopDailyExtPull",

  props: {
    value: Boolean,
    title: String,
  },
  components: {
    SearcherDatetimeRange
  },

  data: () => ({
    dialog: false,
    datetimeRage: [
      new Date(new Date().getTime() - 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10),
      new Date(new Date().getTime() - 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10),
    ],
    datetimeRageChanged: false,
  }),

  methods: {
    extPull() {
      if (!this.datetimeRage[0] || !this.datetimeRage[1]) {
        this.$snackbar.error(i18n.t("shopDailyReports.Messages.extPullError"));
        return;
      }
      this.$store.dispatch("fullscreenLoadingStop");
      shopDailyReports.extPull({
        date_from: this.datetimeRage[0],
        date_to: this.datetimeRage[1]
      }).then(
        function (response) {
          if(response.data && response.data.status.isOK()){
            this.$snackbar.info(i18n.t("shopDailyReports.Messages.extPullSuccess"))
          }
          this.$store.dispatch("fullscreenLoadingStop")
          this.$emit('extPull', this.dialog)
        }.bind(this)
      )
    }
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.excelFile = null;
        }
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>